import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Locale } from "./types";

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: "en-US",
      setLocale: (locale) => set({ locale }),
    }),
    { name: "aria-locale" },
  ),
);
